<div class="bmc-user-groups bz-space--inset-l">
    <h5 class="bz-space--stack-m">{{'USER_GROUPS.TITLE' | translate}}</h5>
    <div class="bmc-user-groups__wrapper">
      <user-groups-list [menuOptions]="menuOptions"></user-groups-list>
      <user-groups-detail [menuOptions]="menuOptions"></user-groups-detail>
    </div>
</div>
